module.exports = __webpack_public_path__ + "img/5.1e350074.webp";